module.exports = __webpack_public_path__ + "static/media/hraswo_chu.b61c1aff.ogg";